module.exports = "../../../../platform/assets/pageMainIcon/jichudanganlei2.svg";